import React from 'react';
import {Link} from 'react-router-dom';
import styles from '@/styles/home.module.css';

type Article = {
    id: number;
    title: string;
    createTime?: string;
    date?: string;
};

interface ContentBlockProps {
    title: string;
    titleEn?: string;
    articles: Article[];
    linkPath: string;
    showMoreLink?: boolean;
}

const ContentBlock: React.FC<ContentBlockProps> = ({
                                                       title,
                                                       articles,
                                                       linkPath,
                                                       showMoreLink = true
                                                   }) => {
    // Format date from ISO string to MM-DD format
    const formatDate = (dateString: string) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${month}-${day}`;
    };

    return (
        <div className={`${styles.xz_col} ${styles.h360}`}>
            <div className={styles.col_title}>
                <div>
                    <div>{title}</div>
                </div>
                {showMoreLink && <Link to={linkPath}>更多 &gt;&gt;</Link>}
            </div>
            <div className={styles.col_con}>
                <ul className={styles.newsList} style={{padding: 0}}>
                    {articles.length > 0 ? (
                        articles.map((article) => (
                            <li key={article.id}>
                                <Link
                                    to={`${linkPath}/${article.id}`}
                                    title={article.title}
                                >
                                    {article.title}
                                </Link>
                                <span>{article.date || formatDate(article.createTime || '')}</span>
                            </li>
                        ))
                    ) : (
                        <li>暂无内容</li>
                    )}
                </ul>
            </div>
        </div>
    );
};

export default ContentBlock; 